import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=62853b5e&scoped=true&"
import script from "./InputColor.vue?vue&type=script&lang=js&"
export * from "./InputColor.vue?vue&type=script&lang=js&"
import style0 from "./InputColor.vue?vue&type=style&index=0&id=62853b5e&scoped=true&lang=css&"
import style1 from "./InputColor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62853b5e",
  null
  
)

export default component.exports